import fetch from '@/helpers/fetch';
import params from '@/lib/params';
import { stringify } from "qs";


export const exUrl = '/api/config/user-config-list';


export function getServiceInfo(content) {
  return fetch.get('/api/config/service-info', content);
}

export function postUpdateService(content) {
  return fetch.post('/api/config/service-edit', null, {
    body: stringify(content)
  });
}
